import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    form: {
      type: Object,
      default: {}
    },
    uploadToken: String
  },
  data: function data() {
    return {
      yingye: {
        form: {},
        rules: {},
        edit1: false,
        edit2: false,
        edit3: false,
        edit4: false
      },
      storeForm: _objectSpread({}, this.form),
      //店铺信息
      businessLicenseForm: _objectSpread({}, this.form),
      //营业执照
      taxpayerForm: _objectSpread({}, this.form),
      //税务信息
      legalPersonForm: _objectSpread({}, this.form),
      //法人信息
      uploadData: {
        data: {
          token: this.uploadToken,
          key: ''
        },
        accept: '.png,.jpeg,.jpg',
        class: 'avatar-uploader',
        action: 'https://up-z2.qiniup.com',
        'show-file-list': false,
        multiple: false
      }
    };
  },
  methods: {
    clickEdit: function clickEdit(i) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var key;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.yingye['edit' + i]) {
                  _context.next = 8;
                  break;
                }

                key = {};
                if (i == 1) key = _objectSpread(_objectSpread({}, _this.businessLicenseForm), {}, {
                  type: 2
                });else if (i == 2) key = _objectSpread(_objectSpread({}, _this.legalPersonForm), {}, {
                  type: 3
                });else if (i == 3) key = _objectSpread(_objectSpread({}, _this.taxpayerForm), {}, {
                  type: 4
                });else if (i == 4) key = _objectSpread({}, _this.storeForm);
                _context.next = 5;
                return _this.onSubmit(key);

              case 5:
                _this.yingye['edit' + i] = false;
                _context.next = 9;
                break;

              case 8:
                _this.yingye['edit' + i] = true;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onSubmit: function onSubmit(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var loading;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loading = _this2.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                _context2.next = 3;
                return _this2.$api.updateInformation(item);

              case 3:
                _this2.$emit('dataBindBasics');

                if (!item.type) {
                  YL.message('修改成功');
                } else {
                  YL.message('等待审核');
                }

                loading.close();
                return _context2.abrupt("return", true);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    cityChange: function cityChange(e) {
      e[0] && this.$set(this.businessLicenseForm, 'businessLicenseProvince', e[0]);
      e[1] && this.$set(this.businessLicenseForm, 'businessLicenseCity', e[1]);
      e[2] && this.$set(this.businessLicenseForm, 'businessLicenseDistrict', e[2]);
    },
    // 图片上传
    handleSuccess: function handleSuccess(response, key, data) {
      this.$set(data, key, this.VUE_APP_IMG_BASE + response.key);

      if (key == 'storeLogo') {
        this.$set(this.yingye.form, 'storeLogo', this.VUE_APP_IMG_BASE + response.key);
      } // this.$refs['formData'].clearValidate(key)

    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'pic')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    handleChange: function handleChange(e) {
      if (this.legalPersonForm.legalPersonIdCardTimeFrom) {
        this.legalPersonForm.legalPersonIdCardLongTime = false;
      }
    },
    handleChangeChecked: function handleChangeChecked(e) {
      if (this.legalPersonForm.legalPersonIdCardLongTime) {
        this.legalPersonForm.legalPersonIdCardTimeFrom = '';
        this.legalPersonForm.legalPersonIdCardTimeTo = '';
      }
    }
  },
  computed: {
    yingyeEdit1: function yingyeEdit1() {
      return this.yingye.edit1;
    },
    yingyeEdit2: function yingyeEdit2() {
      return this.yingye.edit2;
    },
    yingyeEdit3: function yingyeEdit3() {
      return this.yingye.edit3;
    },
    yingyeEdit4: function yingyeEdit4() {
      return this.yingye.edit4;
    }
  },
  created: function created() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this3.yingye = _objectSpread(_objectSpread({}, _this3.yingye), {}, {
                form: _objectSpread({}, _this3.form)
              });

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};